export const TimeBeforeShiftType = Object.freeze({
    Hours: 0,
    Days: 1,
});
